// extracted by mini-css-extract-plugin
export default {"container":"FeedbackList_container__hL7Ss","correct":"FeedbackList_correct__et8Nw","incorrect":"FeedbackList_incorrect__g1NDk"};